import { FieldDate } from "components/Common/Field/Date";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";

type Props<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label: string;
};

export const FormDatePicker = <TFieldValues extends FieldValues>({ name, ...rest }: Props<TFieldValues>) => {
  const methods = useFormContext<TFieldValues>();

  if (!methods) {
    throw new Error("FormDatePicker must be used inside a <Form />");
  }

  return (
    <Controller
      control={methods?.control}
      name={name}
      render={({ formState: { errors }, field: { value, onChange } }) => {
        return (
          <FieldDate
            error={errors.date?.message}
            inputProps={{
              name,
              value,
              onChange,
            }}
            {...rest}
          />
        );
      }}
    />
  );
};
